// "What's new in Pipsqueak" — the feature notes shown on the dashboard.
//
// Static on purpose: these are product announcements, written for MSPs, not commit
// messages. Add a new entry at the top when a feature ships; the dashboard shows the
// newest five. `screen` is optional — when set, the entry links to where the feature lives.

export const WHATS_NEW = [
  {
    date: "2026-10-08",
    title: "Scan results on your phone",
    desc: "Scan results and organization panels are reworked for small screens.",
    screen: "organizations",
  },
  {
    date: "2026-10-07",
    title: "Freshservice integration",
    desc: "Connect Freshservice with your domain and API key.",
    screen: "integrations",
  },
  {
    date: "2026-10-07",
    title: "Public IP and Dark web lead magnets",
    desc: "Visitors can check a domain, an IP address or an email, with the email now optional.",
    screen: "lead-magnet",
  },
  {
    date: "2026-10-05",
    title: "Quick actions in the sidebar",
    desc: "Hover any area in the sidebar to jump to a page, start something new or open a recent item.",
  },
  {
    date: "2026-10-02",
    title: "Redesigned Report Builder",
    desc: "A rebuilt editor for designing branded reports, page by page.",
    screen: "templates",
  },
];

export const latestWhatsNew = (n = 5) => WHATS_NEW.slice(0, n);
